/**
 * @author Brendan Magee
 * @desc Form for users to set their Slack username, which is used for easy notifications
 * @example <slack-username
 *            user="user"
 *            integrations="integrations"
 *            prompt-text="prompt string"
 *            set-integration="updateIntegration(integration)"
 *          >
 *          </slack-username>
 */

import template from './slackUsername.html';

function SlackUsernameController($translate, peopleService) {
  this.$onInit = () => {
    const { preferences = {} } = this.user;
    const [firstIntegration = {}] = this.integrations;

    this.preferences = preferences;
    this.prompt = this.promptText ? $translate.instant(this.promptText) : null;
    this.username = null;
    this.showInput = true;

    this.savingUsername = {
      enable: false,
      success: null
    };

    if (this.preferences.slackUsername) {
      const { slackUsername = '' } = this.preferences;
      this.currentUsername = $translate.instant('YOUR_SLACK_USERNAME', {
        slackUsername
      });
      this.username = slackUsername.startsWith('@')
        ? slackUsername.slice(1)
        : slackUsername;
      this.showInput = false;
    }

    if (preferences.defaultNotificationTarget) {
      const { defaultNotificationTarget: target } = preferences;
      this.selectedIntegration =
        target.type === 'slack'
          ? this.integrations.find((i) => i.id === target.integrationID)
          : firstIntegration;
    } else {
      this.selectedIntegration = firstIntegration;
    }
  };

  this.setSlackUsername = () => {
    this.savingUsername.enable = true;

    const payload = {
      integrationID: this.selectedIntegration.id,
      username: this.username.startsWith('@')
        ? this.username
        : `@${this.username}`
    };

    peopleService.setSlackUsername(payload).then(
      (preferences) => {
        const { slackUsername } = preferences;
        this.savingUsername.enable = false;
        this.savingUsername.success = true;

        if (this.parent && this.parent.targetData) {
          const { slack } = this.parent.targetData;
          slack.channel = payload.username;
          slack.username = payload.username;
        } else if (this.user && this.user.preferences) {
          this.user.preferences.slackUsername = payload;
        }

        if (this.setIntegration) {
          // Save the correct Slack integration ID after validation
          this.setIntegration({ integration: this.selectedIntegration });
        }

        this.currentUsername = $translate.instant('YOUR_SLACK_USERNAME', {
          slackUsername
        });
        this.showInput = false;
      },
      () => {
        this.savingUsername.enable = false;
        this.savingUsername.success = false;
      }
    );
  };
}

const slackUsername = {
  template,
  bindings: {
    user: '<',
    integrations: '<',
    setIntegration: '&?',
    promptText: '@?'
  },
  require: {
    parent: '?^^defaultNotificationTarget'
  },
  controller: 'SlackUsernameController'
};

const controllerArray = [
  '$translate',
  'peopleService',
  SlackUsernameController
];

export default function (ngModule) {
  ngModule.component('slackUsername', slackUsername);
  ngModule.controller('SlackUsernameController', controllerArray);
}
